import { render, staticRenderFns } from "./BoxReceivingIcon.vue?vue&type=template&id=40603d1b&"
import script from "./BoxReceivingIcon.vue?vue&type=script&lang=js&"
export * from "./BoxReceivingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports